export default __webpack_public_path__ + "static/media/User.c85b7f19.svg";